import _ from 'lodash';

import utils from 'app/actions/utils';
import millieApi from 'app/apis/millie';
import history from 'app/history';
import paths from 'app/paths';
import AuthSlx from 'app/selectors/auth';

const Types = {
  SUBMIT: 'CLAIM_SUBMIT',
};

const Actions = {

  submit: (nonprofitId) => (dispatch, getState) => {
    const promise = nonprofitId
      ? millieApi.nonprofitsClaim(nonprofitId)
      : Promise.reject(utils.mockServerValidations({nonprofitId: ['required']}));
    promise.then(() => {
      process.nextTick(() => { // let the other `then()` go first
        const nonprofitAdmins = AuthSlx.nonprofitAdmins(getState());
        const npa = nonprofitAdmins.find((npa) => npa.nonprofit.id === nonprofitId);
        history.push(paths.nonprofitProfileEdit(npa.nonprofitProfile.id));
      });
    });
    return dispatch({ type: Types.SUBMIT, promise, nonprofitId });
  },

};

export {
  Types,
};

export default Actions;
